import { nanoid } from 'nanoid';

const USER_ID_KEY = 'ai-chat-user-id';

/**
 * Gets the user ID from Clerk if signed in, otherwise uses localStorage fallback
 * This function should be called from client components with access to useUser hook
 */
export function getUserId(clerkUserId?: string | null): string {
  // If Clerk user ID is provided, use it
  if (clerkUserId) {
    return clerkUserId;
  }

  // Only run localStorage fallback on the client side
  if (typeof window === 'undefined') return '';

  let userId = localStorage.getItem(USER_ID_KEY);

  if (!userId) {
    // Generate a new user ID and store it (for anonymous users)
    userId = nanoid();
    localStorage.setItem(USER_ID_KEY, userId);
  }

  return userId;
}

export function updateUserId(newUserId: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(USER_ID_KEY, newUserId);
} 